import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 30 15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 15v-3h30v3zm0-9h30v3H0zm0-6h30v3H0z" fill="#1a1a1a" fillRule="evenodd" /></svg>);